var map = {
	"./GLA_University_logo.png": 8611,
	"./HackerRank_logo.png": 9904,
	"./address_image.svg": 599,
	"./animated_ashutosh.png": 7875,
	"./animated_logo.svg": 7733,
	"./blogs_image.svg": 2885,
	"./cloud_infrastructure.svg": 7957,
	"./codeInLogo.png": 7935,
	"./codility.webp": 3374,
	"./contactMail.png": 9581,
	"./coursera_logo.png": 1877,
	"./data_science.svg": 8938,
	"./deeplearning_ai_logo.png": 2862,
	"./delhivery_logo.png": 4625,
	"./developerActivity.svg": 6715,
	"./devslane.png": 325,
	"./dsc_logo.png": 6390,
	"./education.svg": 855,
	"./experience.svg": 9917,
	"./feelingProud.svg": 658,
	"./freecopy_logo.png": 9273,
	"./freelance.png": 4346,
	"./fullstack.svg": 2043,
	"./gcp_logo.png": 1513,
	"./github_logo.png": 9551,
	"./googleAssistant.jpg": 700,
	"./googleAssistant.svg": 3564,
	"./google_logo.png": 5927,
	"./greeting.gif": 2979,
	"./ibm_logo.png": 9561,
	"./iiitk_logo.png": 5241,
	"./intel_logo.jpg": 3026,
	"./iu_logo.png": 1576,
	"./jsFramework.svg": 8446,
	"./kritarth.jpeg": 5254,
	"./legato_logo.png": 5112,
	"./logo-udemy.svg": 4918,
	"./manOnTable.svg": 3034,
	"./microsoft_logo.png": 7231,
	"./mozilla_logo.png": 9592,
	"./muffito_logo.png": 2295,
	"./nextuLogo.jpg": 1631,
	"./nptel_logo.png": 8936,
	"./portfolio.gif": 3549,
	"./programmer.svg": 9220,
	"./projects_image.svg": 4716,
	"./pwa.png": 7758,
	"./saayaHealthLogo.png": 6006,
	"./sprite.svg": 9114,
	"./stanford_logo.png": 7137,
	"./talksCardBack.svg": 5331,
	"./talksCardBackAlt.svg": 7945,
	"./tiktok_logo.png": 2032,
	"./ui_ux_design.svg": 2337,
	"./work-images/briidge/screen1.png": 789,
	"./work-images/briidge/screen2.png": 2388,
	"./work-images/briidge/screen3.png": 2476,
	"./work-images/briidge/screen4.png": 999,
	"./work-images/briidge/screen5.png": 7160,
	"./work-images/briidge/screen6.png": 4192,
	"./work-images/briidge/screen7.png": 3950,
	"./work-images/briidge/screen8.png": 9671,
	"./work-images/conectar/screen1.jpg": 6585,
	"./work-images/conectar/screen10.jpg": 8946,
	"./work-images/conectar/screen11.jpg": 6245,
	"./work-images/conectar/screen12.jpg": 4267,
	"./work-images/conectar/screen13.jpg": 85,
	"./work-images/conectar/screen14.jpg": 6685,
	"./work-images/conectar/screen15.jpg": 9969,
	"./work-images/conectar/screen16.jpg": 35,
	"./work-images/conectar/screen17.jpg": 5478,
	"./work-images/conectar/screen18.jpg": 6011,
	"./work-images/conectar/screen2.jpg": 9771,
	"./work-images/conectar/screen3.jpg": 5934,
	"./work-images/conectar/screen4.jpg": 2299,
	"./work-images/conectar/screen5.jpg": 6799,
	"./work-images/conectar/screen6.jpg": 5356,
	"./work-images/conectar/screen7.jpg": 7139,
	"./work-images/conectar/screen8.jpg": 4942,
	"./work-images/conectar/screen9.jpg": 9064,
	"./work-images/fitbuddy/screen1.png": 620,
	"./work-images/fitbuddy/screen2.png": 9295,
	"./work-images/fitbuddy/screen3.png": 8654,
	"./work-images/fitbuddy/screen4.png": 9350,
	"./work-images/fitbuddy/screen5.png": 748,
	"./work-images/fitbuddy/screen6.png": 2091,
	"./work-images/hellotax/screen1.png": 1614,
	"./work-images/hellotax/screen10.png": 6265,
	"./work-images/hellotax/screen11.png": 9526,
	"./work-images/hellotax/screen12.png": 2807,
	"./work-images/hellotax/screen13.png": 4095,
	"./work-images/hellotax/screen14.png": 8835,
	"./work-images/hellotax/screen15.png": 9302,
	"./work-images/hellotax/screen16.png": 714,
	"./work-images/hellotax/screen17.png": 723,
	"./work-images/hellotax/screen18.png": 7899,
	"./work-images/hellotax/screen2.png": 7157,
	"./work-images/hellotax/screen3.png": 8415,
	"./work-images/hellotax/screen4.png": 5573,
	"./work-images/hellotax/screen5.png": 8717,
	"./work-images/hellotax/screen6.png": 5487,
	"./work-images/hellotax/screen7.png": 8327,
	"./work-images/hellotax/screen8.png": 361,
	"./work-images/hellotax/screen9.png": 5459,
	"./work-images/portfolio/screen1.png": 9579,
	"./work-images/portfolio/screen2.png": 9218,
	"./work-images/portfolio/screen3.png": 2597,
	"./work-images/portfolio/screen4.png": 4117,
	"./work-images/portfolio/screen5.png": 380,
	"./work-images/portfolio/screen6.png": 2751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;